<template>
  <div class="clause-wrapper">
    <div class="clause-body">
      <div class="header">优驾保费率说明</div>
      <div class="content">
        本产品采用先根据运输距离冻结固定预估保费，然后在行驶结束后根据安全行驶情况确定最终费率，享受安全驾驶优惠，鼓励车主养成良好驾驶习惯，减少事故；
      </div>
      <div class="content">1、先根据运输距离固定最高保费规则</div>
      <div class="content">
        每次运输在录申报单时，系统根据当次行驶距离长短就固定最高预估费率，并将预估保费从充值保费中进行预扣，相关折扣费率如下:
      </div>
      <img src="../assets/productRateDescription1.png" alt="" />
      <div class="content">2、行驶完成后奖励</div>
      <div class="content">
        行驶完成后根据车辆行驶安全评分进行保费奖励，在预估保费上进行扣减，得到最终确定保费金额，释放多余冻结保费；
      </div>
      <img src="../assets/productRateDescription2.png" alt="" />
      <div class="content" style="margin-bottom: 14vw">
        注：1、返费后不得低于最低收费；2、四舍五入到分；
      </div>
      <div class="close-btn" @click="closeClause">关闭</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerPage",
  methods: {
    closeClause() {
      this.$router.back(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.clause-wrapper {
  overflow-y: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;

  .clause-body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 80vh;
    color: #333;
    background-color: #fff;
    z-index: 9999;
    -webkit-transition: 300ms all;
    transition: 300ms all;
    overflow: auto;

    .header {
      height: 13.33vw;
      line-height: 13.33vw;
      font-size: 4.8vw;
      font-weight: bold;
      text-align: center;
    }

    .content {
      width: 90%;
      font-size: 3.6vw;
      line-height: 1.2;
      text-indent: 7.3vw;
      text-align: left;
      margin: 0 auto;
    }

    img {
      display: block;
      margin: 3.6vw auto;
      width: 90%;
    }

    .close-btn {
      width: 100vw;
      height: 12vw;
      line-height: 12vw;
      text-align: center;
      color: #ffffff;
      background: #3385ff;
      position: fixed;
      bottom: 0;
    }
  }
}
</style>
